import { Component, OnInit } from '@angular/core';
import { TaskFeedbackService } from '../../../services/task-feedback.service';
import { TaskHistoryService } from '../../../services/task-history.service';
import { PriorityViewModel } from 'app/models/PriorityViewModel';
import { forkJoin } from 'rxjs';
import { SessionStorageService } from '../../../services/session-storage.service';
import { finalize } from 'rxjs/operators';
import TaskTypes = Boo.Objects.Enums.TaskTypeEnum;

@Component({
  selector: 'app-components-specialist-viewtaskfeedback',
  templateUrl: './ViewTaskFeedback.component.html',
  styleUrls: ['./ViewTaskFeedback.component.scss']
})
export class ViewTaskFeedbackComponent implements OnInit {
  public isLoading = true;
  public filteredFeedback: Boo.Objects.TaskFeedback[] = [];
  public taskIdFilter = '';
  public noFeedback = 'No feedback provided.';
  public expandedFeedbackIds = new Set<number>();

  private feedback: Boo.Objects.TaskFeedback[] = [];
  private taskTypes: Boo.Objects.TaskType[];

  private taskTypeControlStrings: Partial<Record<TaskTypes, string>> = {
    [TaskTypes.OnsiteRecommendationCreateContent]: 'app-components-onsite-recommendations-feedback',
    [TaskTypes.PageCreationCreateContent]: 'app-components-page-optimization-feedback',
    [TaskTypes.PageCreationRewriteContent]: 'app-components-page-optimization-feedback',
    [TaskTypes.PageOptimizationCreateContent]: 'app-components-page-optimization-feedback',
    [TaskTypes.PageOptimizationRewriteContent]: 'app-components-page-optimization-feedback'
  };

  constructor(
    private taskFeedbackService: TaskFeedbackService,
    private taskHistoryService: TaskHistoryService,
    private sessionStorageService: SessionStorageService) { }

  ngOnInit(): void {
    forkJoin([this.sessionStorageService.getStaticData(), this.taskFeedbackService.get()])
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe(([staticData, feedback]) => {
        this.taskTypes = staticData.TaskTypes
        this.feedback = feedback;
        this.filterFeedback();
      });
  }

  public toggleFeedback(taskFeedbackId: number): void {
    if (this.expandedFeedbackIds.has(taskFeedbackId)) {
      this.expandedFeedbackIds.delete(taskFeedbackId);
    } else {
      this.expandedFeedbackIds.add(taskFeedbackId);
    }
  }

  public filterFeedback() {
    this.filteredFeedback = this.feedback.filter(x => !this.taskIdFilter || x.TaskId.toString().startsWith(this.taskIdFilter));
  }

  public displayTaskType(type: TaskTypes): string {
    return this.taskTypes.find(x => x.TaskTypeEnum == type)?.Name ?? "N/A";
  }

  hasDetails(feedback: Boo.Objects.TaskFeedback): boolean {
    switch (feedback.Task.TaskTypeEnum) {
      case TaskTypes.OnsiteRecommendationCreateContent:
        return !!feedback.TaskHistoryInfo;
      case TaskTypes.PageCreationCreateContent:
      case TaskTypes.PageCreationRewriteContent:
      case TaskTypes.PageOptimizationCreateContent:
      case TaskTypes.PageOptimizationRewriteContent:
        return true;
    }
    return false;
  }

  public show(feedback: Boo.Objects.TaskFeedback) {
    switch (feedback.Task.TaskTypeEnum) {
      case TaskTypes.OnsiteRecommendationCreateContent:
        this.showTaskHistory(feedback.TaskHistoryInfo.TaskHistoryId, feedback.Task.TaskTypeEnum);
        break;
      case TaskTypes.PageCreationCreateContent:
      case TaskTypes.PageCreationRewriteContent:
      case TaskTypes.PageOptimizationCreateContent:
      case TaskTypes.PageOptimizationRewriteContent:
        this.showTasks(feedback);
        break;
    }
  }

  private showTaskHistory(taskHistoryId: number, taskType: TaskTypes) {
    this.taskHistoryService
      .get(taskHistoryId)
      .subscribe(history => {
        const controlString = this.taskTypeControlStrings[taskType];
        if (controlString) {
          PriorityViewModel.show(controlString, { history: history});
        } else {
          toastr.error('Task type not supported.');
        }
      });
  }

  private showTasks(feedback: Boo.Objects.TaskFeedback): void {
    const controlString = this.taskTypeControlStrings[feedback.FeedbackTask.TaskTypeEnum]
      || this.taskTypeControlStrings[feedback.Task.TaskTypeEnum];

    if (!controlString) {
      toastr.error('Task type not supported.');
      return;
    }

    PriorityViewModel.ngShow(controlString, { taskFeedbackId: feedback.TaskFeedbackId });
  }
}
